import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { useLang } from "@/i18n";

export default function MarqueeStrip() {
  const { t } = useLang();
  const items = t("marquee_items");
  return (
    <div
      data-testid="marquee-strip"
      className="border-y border-white/10 bg-[#0B1120] py-7 overflow-hidden"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="flex items-center">
            <span className="font-display uppercase font-semibold text-3xl md:text-5xl text-white/85 tracking-tight mx-8">
              {item}
            </span>
            <Asterisk className="text-[#ED1C24]" size={34} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
